import React from 'react';
import SectionBox from '../../components/SectionBox';
import '../../styles/resources/content.scss';
import Header from '../../components/Header';

/**
 * Content item for resources
 */
const HandoutsProfessionals = () => (
  <div>
    <Header short backgroundImage={require('../../images/group.jpg')} backgroundPosition="center 35%">
      <h1>For Professionals</h1>
    </Header>
    <div className="resources-content content-item">
      <SectionBox>
        <h2>Articles and Papers</h2>
        <ul>
          <li><a href="http://www.texascounseling.org/articles/ASystematicApproachtoReunificationTherapy.pdf" target="_blank" rel="noopener noreferrer">A Systematic Approach to Reunification Therapy</a> by Christy Bradshaw Schmidt, LPC</li>
          <li><a href="/documents/Advanced_2013_Paper_with_Judge_Marr.pdf" target="_blank" rel="noopener noreferrer">A Judge's Guide to the 10 Most Difficult Issues in Child Custody Matters</a> by Christy Bradshaw Schmidt, LPC with the Honorable Judge Jack Marr</li>
          <li><a href="http://www.texascounseling.org/articles/ExerptSittingIn2007_10.pdf" target="_blank" rel="noopener noreferrer">Failing to Plan is Planning to Fail</a> by Aaron Robb, Ph.D.</li>
          <li><a href="/documents/Hollwarth_2026_Reunification_Therapy_What_Is_It_Good_For.pdf" target="_blank" rel="noopener noreferrer">Reunification Therapy: What Is It Good For</a> — Posted with permission from Christian Hollwarth, the author, from her presentation at the 2026 Texas Bar Advanced Family Law Program.</li>
        </ul>
      </SectionBox>
      <SectionBox>
        <h2>Handouts</h2>
        <ul>
          <li><a href="/documents/Communicating_with_your_evaluator.pdf" target="_blank" rel="noopener noreferrer">Attorney/Custody Evaluator Communications</a></li>
          <li><a href="/documents/Therapy_Records_Request.pdf" target="_blank" rel="noopener noreferrer">Records Requests</a></li>
          <li><a href="/documents/Custody_Recommendations.pdf" target="_blank" rel="noopener noreferrer">Therapists and Custody Recommendations</a></li>
          <li><a href="/documents/Eliminating_parenting_time_recommendations_from_therapy_reports.pdf" target="_blank" rel="noopener noreferrer">Advice on Recommendations Therapists Can Make</a></li>
        </ul>
      </SectionBox>
      <SectionBox>
        <h2>Trainings</h2>
        <ul>
          <li><a href="https://www.fletcherphd.com/reunification-therapist-training" target="_blank" rel="noopener noreferrer">Advanced Training for Reunification Therapists</a> by Susan Fletcher, Ph.D. and Christy Bradshaw Schmidt, LPC</li>
          <li><a href="https://www.afccnet.org/Webinars/Monthly-Webinar-Archives" target="_blank" rel="noopener noreferrer">AFCC Monthly Webinar Archives</a></li>
          <li><a href="https://texasafcc.org/resources/" target="_blank" rel="noopener noreferrer">Texas Chapter of AFCC Webinar Archive</a> (scroll way down)</li>
          <li><a href="https://betweentwohomes.com/supervised-visitation" target="_blank" rel="noopener noreferrer">Supervised Visitation training</a></li>
          <li><a href="https://www.tammiaxelsonlmsw.com/general-1" target="_blank" rel="noopener noreferrer">Custody, Adoption, and Family Violence issues training</a> from Dr. Tammi Axelson</li>
          <li><a href="https://training.concept.paloaltou.edu/collections" target="_blank" rel="noopener noreferrer">Palo Alto University</a> (hundreds of on demand forensic specialty training CEs)</li>
          <li><a href="https://www.youtube.com/playlist?list=PL2Z5F_4X2pTFe0imkZE3gy46pxFH73FEa" target="_blank" rel="noopener noreferrer">University of New Mexico Law and Mental Health series</a> – free!</li>
        </ul>
      </SectionBox>
    </div>
  </div>
);

export default HandoutsProfessionals;
